import { FC } from "preact/compat";
import { getOcrColor } from "~/core/color-manager";
import { FigureItemProps } from "./interfaces";

const getCoords = (boundaries: number[]) => {
    const coords: [number, number][] = [];

    for (let i = 0; i < boundaries.length; i += 2) {
        const x = boundaries[i];
        const y = boundaries[i + 1];

        coords.push([x, y]);
    }

    return coords;
};

const FigureItem: FC<FigureItemProps> = ({ figure }) => {
    const coords = getCoords(figure.boundaries);
    const pathD = coords
        .map(([x, y], i) => (i === 0 ? `M ${x} ${y}` : `L ${x} ${y}`))
        .concat(["Z"])
        .join(" ");
    const color = getOcrColor(figure.score);

    if (coords.length < 1) {
        return null;
    }

    return (
        <>
            <path
                d={pathD}
                fill={`${color}55`}
                stroke={color}
                strokeWidth="1"
            />
        </>
    );
};

export default FigureItem;
